import { defineComponent as _defineComponent } from 'vue'

export enum OzMembershipTierGridVariant {
  // Expanded: 4x1 | Not expanded: 2x2
  Default = 'Default',
  // Expanded: 3x1 | Not expanded: 2x2
  SchoolLibrary = 'SchoolLibrary',
  // Expanded: 4x1 | Not expanded: 2x2
  SingleStep = 'SingleStep',
}

const __default__ = {}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzMembershipTierGrid',
  props: {
    isExpanded: { type: Boolean, default: true },
    variant: { default: OzMembershipTierGridVariant.Default }
  },
  setup(__props: any) {

/**
 * @file This component handles the membership tier grids.
 */



return { __sfc: true,OzMembershipTierGridVariant }
}

})